import React, { useEffect, useRef, useState } from "react";
import { BsArrowDownShort } from "react-icons/bs";
import { useReactToPrint } from "react-to-print";
import Swal from "sweetalert2";
import { Loading } from "../../../../../components/Loading";
import { BrComerceApiService } from "../../../../../services/BrComerceApiService";
import logoBr from '../../../../../assets/logo/logo-brcomerce.png'
import miniLogo from '../../../../../assets/logo/mini-logo.png'
import formatCep from "../../../../../utils/FormatCep";
import styles from "./styles.module.scss";
import moment from "moment";
import { formatOwnCollectStartAndEnd } from "../../../../../utils/OwnCollectTime";

const CollectTag = () => {
  const api = new BrComerceApiService();
  const width = window.innerWidth

  const [tag, setTag] = useState({});
  const [loading, setLoading] = useState(false);
  const [one, setOne] = useState(false);


  const componentRef = useRef();
  const containerForPrintTags = useRef(null);
  const [showHelperForPrint, setShowHelperForPrint] = useState(true);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    copyStyles: () => true,
    pageStyle: () => `
      @page {
        size: ${one ? "100mm 150mm !important" : "A4 !important"};
        padding: 0 !important;
        margin: 3mm !important;
      }
    `
  });

  const goToPrintContainer = () => {
    containerForPrintTags.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "start"
    });
  };

  const onScroll = e => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    const totalScrolled = scrollTop + clientHeight;

    if (Number(totalScrolled.toFixed()) === scrollHeight) {
      setShowHelperForPrint(false);
    } else {
      setShowHelperForPrint(true);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll, true);

    // Remove the event listener
    return () => {
      window.removeEventListener("scroll", onScroll, true);
    };
  }, []);

  useEffect(() => {
    const dataStore = window.localStorage.getItem("Brcom:EtiquetaColeta");

    if (dataStore) {
      const ownCollectId = JSON.parse(dataStore);
      setLoading(true);

      api.makeHttpRequest({
        method: "POST",
        url: `/own-collect/generateTag`,
        data: {
          id: ownCollectId,
        }
      })
        .then(async response => {
          setTag(response);
        })
        .catch(error => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "Etiquetas",
            text: "Não foi possível gerar etiquetas."
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, []);

  return (
    <main className={styles.main}>
      <Loading loading={loading} />
      <div className={styles.container}>
        <h2 className={styles.title}>Impressão de Etiqueta</h2>
        <div ref={componentRef} className={styles.content}>
          {!loading && tag && (
            <div className={styles.etiqueta}>
              <div className={`${styles.head}`}>
                <div>
                  <img src={logoBr} id="img-logo" alt="logo empresa" />
                </div>
                <div>
                  <img
                    src={miniLogo}
                    id="img-mini-logo"
                    alt="mini logo"
                    style={{ paddingTop: '20px' }}
                  />
                </div>
              </div>

              <div className={styles.collect}>
                <div className={styles.collectHead}>
                  <span>ENDEREÇO DA COLETA:</span>
                </div>

                <div className={styles.collectBody}>
                  <div className={`${styles["collect-data"]}`}>
                    <span>{tag?.destination?.name}</span>
                    <span>
                      {tag?.destination?.street} {tag?.destination?.number ? `, ${tag?.destination?.number}` : ''}
                      <br />
                      {tag?.destination?.complement ? `${tag?.destination?.complement}` : ''}
                    </span>
                    <span>{tag?.destination?.district}</span>
                    <span className={styles.cepContainer}>
                      {formatCep(tag?.destination?.zip)} {" "} {tag?.destination?.city}
                      {tag?.destination?.state ? ` - ${tag?.destination?.state}` : ''}
                    </span>
                    <div className={styles.obs}>obs: {tag?.destination?.observation}</div>
                  </div>

                  <div className={styles.collectInfo}>
                    <span className={styles.hourTitle}>Data e Hora Agendada:</span>
                    <span className={styles.hour}>{`${moment(tag?.collectTimeStart || tag?.collectTimeEnd).format("DD/MM/YYYY")}, ${formatOwnCollectStartAndEnd(tag?.collectTimeStart, tag?.collectTimeEnd)}`}</span>
                  </div>
                </div>
              </div>

              <div className={styles.tracking}>
                <div className={styles.barCode}>
                  {tag?.tagBarCode && <img
                    src={`data:image/jpeg;base64,${tag?.tagBarCode}`}
                    alt="CODIGO DE BARRAS"
                  />}
                </div>
                <div className={styles.rastreio}>
                  <span>
                    {tag?.id}
                  </span>
                </div>
              </div>

              <div className={styles.coletador}>
                <p>
                  Assinatura do coletador: <span></span>
                </p>
                <div>
                  <p>
                    Documento: <span></span>
                  </p>
                  <p>
                    Data de entrega: <span style={{ width: '42%' }}></span>
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <aside className={styles.aside}>
        <div className={styles.printOpts}>
          <h2>Opções de impressão</h2>

          <div className={styles.switchOption}>
            <span>Uma etiqueta por folha</span>
            <label className={styles.switch}>
              <input
                type="checkbox"
                onChange={() => setOne(!one)}
                checked={one}
              />
              <span className={`${styles.slider} ${styles.round}`}></span>
            </label>
          </div>
        </div>
        <div ref={containerForPrintTags} className={styles.summary}>
          <h2>Resumo da impressão</h2>

          <div className={styles.summaryResume}>
            <div>
              <p>
                <strong>Objetos:</strong>
              </p>
              <span>{tag?.packages} Objetos</span>
            </div>
          </div>
        </div>
        <button className={styles.button} onClick={() => handlePrint()}>
          Imprimir Etiquetas
        </button>
      </aside>

      {showHelperForPrint && width <= 880 && (
        <div
          className={`${styles.goToPrintContainer}`}
          onClick={goToPrintContainer}
        >
          <button type="button">
            Imprimir Etiquetas <BsArrowDownShort />
          </button>
        </div>
      )}
    </main>
  );
};

export { CollectTag };

